const SAFE_PROTOCOLS = new Set(["https:", "http:", "mailto:", "tel:"])

/**
 * Validates a CMS-provided URL and returns it only if it uses a safe scheme.
 * Blocks javascript:, data:, vbscript:, and anything else unexpected.
 * Relative paths (starting with / or #) are always allowed.
 */
export function safeHref(url: string | undefined | null): string {
  if (!url) return "#"
  const trimmed = url.trim()
  if (trimmed.startsWith("/") || trimmed.startsWith("#")) return trimmed
  try {
    const { protocol } = new URL(trimmed)
    return SAFE_PROTOCOLS.has(protocol) ? trimmed : "#"
  } catch {
    return trimmed
  }
}
